import {createSlice} from "@reduxjs/toolkit";

const initialActiveVasOffersState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  activeVasOffersList: null,
  activeVasOfferForEdit: undefined,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const activeVasOffersSlice = createSlice({
  name: "activeVasOffers",
  initialState: initialActiveVasOffersState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    myActiveVasOffersFetched: (state, action) => {
      const { activeVasOffersList } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.activeVasOffersList = activeVasOffersList;
    },
    vasOfferActivated: (state, action) => {
      // const { activeVasOffersList } = action.payload;
      state.actionsLoading = false;
      state.error = null;
      // state.activeVasOffersList = activeVasOffersList;
    },
    // activeVasOffersUpdateState
    activeVasOffersStatusUpdated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { ids, status } = action.payload;
      state.entities = state.entities.map(entity => {
        if (ids.findIndex(id => id === entity.id) > -1) {
          entity.status = status;
        }
        return entity;
      });
    }
  }
});
